module.exports = __webpack_public_path__ + "img/lokum.0f210eac.svg";